<template>
  <el-main>
    <el-row type="flex">
      <el-button style="margin-right: 10px;" width="100px;" type="primary" @click="getList">{{$t('default.refresh')}}<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button style="margin-right: 10px;" width="100px;" type="primary" @click="dialogFormVisible = true">{{$t('default.createdOrg')}}</el-button>
    </el-row>
    <el-table style="margin-top: 10px" border v-loading="loading" :data="organizations">
      <el-table-column prop="name" :label="$t('default.name')">
      </el-table-column>
      <el-table-column prop="remark" :label="$t('default.remark')">
      </el-table-column>
      <el-table-column prop="createdAt" :label="$t('default.createdAt')">
        <template slot-scope="scope">
          {{getDate(scope.row.createdAt)}}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('default.actions')"
        width="100">
        <template slot-scope="scope">
          <el-button @click="edit(scope.row)" type="text" size="small">{{$t('default.edit')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="pageSize"
      layout="prev, pager, next, total"
      :total="total">
    </el-pagination>
    <OrganizationDialog ref="user_dialog" :dialogFormVisible.sync="dialogFormVisible" @refresh="getList"/>
  </el-main>
</template>

<style>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  .el-aside {
    color: #333;
  }
</style>

<script>
// import oss from '../utils/oss'
import OrganizationDialog from '../components/OrganizationDialog.vue'
import moment from 'moment'
export default {
  components: { OrganizationDialog },
  data () {
    return {
      loading: false,
      dialogFormVisible: false,
      mode: 'ai',
      list: [],
      organizations: [],
      pageSize: 10,
      total: 0,
      currentPage: 1
    }
  },
  mounted: async function () {
    this.getList()
    console.log(this.$route)
  },
  methods: {
    getDate (createdAt) {
      return moment(createdAt).format('YYYY-MM-DD HH:mm')
    },
    edit (row) {
      this.$refs.user_dialog.edit(row)
      this.dialogFormVisible = true
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    async getList () {
      this.loading = true
      let result = {}
      try {
        result = await this.$store.dispatch('getOrganizations', {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      } catch (err) {
        console.log(err)
        this.$notify({
          title: '请求失败',
          type: 'error'
        })
        this.loading = false
        return false
      }
      const { code, data } = result.data
      if (code === 0) {
        this.organizations = data.organizations
        this.total = data.total
      }
      this.loading = false
    }
  }
}
</script>
